export default "__VITE_ASSET__B6fnxpIj__"